// src/apis/tbFile/index.ts
import UA from "@ali/tbm-ua";

// src/apis/tbFile/tbFile.themis.tb.ts
import { noop, callThemisSync, callThemis, StatusCodes } from "@ali/abridge";
var defaultBizId = "TaoPiaoPiao";
var getTBFileByThemis = ({ key = "", bizID }) => {
  return new Promise((resolve, reject) => {
    callThemis("kvStorage.getItem", {
      bizID: bizID || defaultBizId,
      key,
      onResult: (r) => {
        if ((r == null ? void 0 : r.statusCode) === StatusCodes.Success) {
          resolve(r == null ? void 0 : r.result);
        } else {
          reject(new Error(`get ${key} error`));
        }
      }
    });
  });
};
var getTBFileByThemisSync = ({ key = "", bizID }) => {
  const res = callThemisSync("kvStorage.getItem", {
    bizID: bizID || defaultBizId,
    key
  });
  return res == null ? void 0 : res.result;
};
var setTBFileByThemis = ({ key = "", value = "", bizID }) => {
  return new Promise((resolve, reject) => {
    callThemis("kvStorage.setItem", {
      bizID: bizID || defaultBizId,
      key,
      value,
      onResult: (r) => {
        if (r.statusCode === StatusCodes.Success) {
          resolve({
            success: true
          });
        } else {
          reject({
            success: false,
            errorMessage: JSON.stringify(r)
          });
        }
      }
    });
  });
};
var setTBFileByThemisSync = ({ key = "", value = "", bizID }) => {
  return callThemisSync("kvStorage.setItem", {
    bizID: bizID || defaultBizId,
    key,
    value
  });
};
var removeTBFileByThemis = ({ key = "", bizID }) => {
  return new Promise((resolve, reject) => {
    callThemis("kvStorage.removeItem", {
      bizID: bizID || defaultBizId,
      key,
      onResult: (r) => {
        if (r.statusCode === StatusCodes.Success) {
          resolve({
            success: true
          });
        } else {
          reject({
            success: false,
            errorMessage: JSON.stringify(r)
          });
        }
      }
    });
  });
};
var removeTBFileByThemisSync = ({ key = "", bizID }) => {
  return callThemisSync("kvStorage.removeItem", {
    bizID: bizID || defaultBizId,
    key
  });
};
var clearTBFileByThemis = ({ bizID }) => {
  return new Promise((resolve, reject) => {
    callThemis("kvStorage.clear", {
      bizID: bizID || defaultBizId,
      onResult: (r) => {
        if (r.statusCode === StatusCodes.Success) {
          resolve({
            success: true
          });
        } else {
          reject({
            success: false,
            errorMessage: JSON.stringify(r)
          });
        }
      }
    });
  });
};
var clearTBFileByThemisSync = ({ bizID }) => {
  return callThemisSync("kvStorage.clear", {
    bizID: bizID || defaultBizId
  });
};
var get = (options, callback = noop) => {
  if (typeof callback === "function" && callback !== noop) {
    return getTBFileByThemis(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return getTBFileByThemis(options);
};
var set = (options, callback = noop) => {
  if (typeof callback === "function" && callback !== noop) {
    return setTBFileByThemis(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return setTBFileByThemis(options);
};
var remove = (options, callback = noop) => {
  if (typeof callback === "function" && callback !== noop) {
    return removeTBFileByThemis(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return removeTBFileByThemis(options);
};
var clear = (options, callback = noop) => {
  if (typeof callback === "function" && callback !== noop) {
    return clearTBFileByThemis(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return clearTBFileByThemis(options);
};
var tbFile = {
  getSync: getTBFileByThemisSync,
  setSync: setTBFileByThemisSync,
  removeSync: removeTBFileByThemisSync,
  clearSync: clearTBFileByThemisSync,
  get,
  set,
  remove,
  clear
};

// src/apis/tbFile/tbFile.windvane.ts
import { callWindVane, noop as noop2, notSupportForPromise } from "@ali/abridge";
var webStoreLib = window.localStorage;
var getTBFileByWindVane = ({ key } = { key: "" }) => {
  return new Promise((resolve, reject) => {
    callWindVane("WVFile.read", {
      fileName: `${key}.txt`,
      share: "true"
    }).then((res) => {
      const { ret, data } = res || {};
      if (ret === "HY_SUCCESS") {
        resolve(data);
      } else if (ret === "HY_FAILED") {
        resolve("");
      } else {
        resolve(webStoreLib.getItem(key));
      }
    }).catch(() => {
      reject(webStoreLib.getItem(key));
    });
  });
};
var get2 = (options, callback = noop2) => {
  if (typeof callback === "function" && callback !== noop2) {
    return getTBFileByWindVane(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return getTBFileByWindVane(options);
};
var setTBFileByWindVane = ({ key, value } = { key: "", value: "" }) => {
  return new Promise((resolve, reject) => {
    callWindVane("WVFile.write", {
      fileName: `${key}.txt`,
      share: "true",
      mode: "overwrite",
      data: value
    }).then(
      (res) => {
        const { ret } = res || {};
        if (ret === "HY_SUCCESS") {
          resolve({});
        } else {
          webStoreLib.setItem(key, value);
          resolve({});
        }
      },
      (err) => {
        webStoreLib.setItem(key, value);
        reject(err);
      }
    );
  });
};
var set2 = (options, callback = noop2) => {
  if (typeof callback === "function" && callback !== noop2) {
    return setTBFileByWindVane(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return setTBFileByWindVane(options);
};
var removeTBFileByWindVane = ({ key } = { key: "" }) => {
  return new Promise((resolve, reject) => {
    callWindVane("WVFile.write", {
      fileName: `${key}.txt`,
      share: "true",
      mode: "overwrite",
      data: ""
    }).then(
      (res) => {
        const { ret } = res || {};
        if (ret === "HY_SUCCESS") {
          resolve({});
        } else {
          webStoreLib.removeItem(key);
          resolve({});
        }
      },
      (err) => {
        webStoreLib.removeItem(key);
        reject(err);
      }
    );
  });
};
var remove2 = (options, callback = noop2) => {
  if (typeof callback === "function" && callback !== noop2) {
    return removeTBFileByWindVane(options).then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return removeTBFileByWindVane(options);
};
var clear2 = (options, callback = noop2) => {
  if (typeof callback === "function" && callback !== noop2) {
    return notSupportForPromise().then((res) => {
      callback(res);
    }).catch((err) => {
      callback(err);
    });
  }
  return notSupportForPromise();
};
var notSupportSync = () => {
  throw new Error("not support sync invoke now");
};
var tbFile2 = {
  getSync: notSupportSync,
  setSync: notSupportSync,
  removeSync: notSupportSync,
  clearSync: notSupportSync,
  get: get2,
  set: set2,
  remove: remove2,
  clear: clear2
};

// src/apis/tbFile/index.ts
import { notSupportForObjForm as notSupport } from "@ali/abridge";
var _tbFile;
if (UA.isThemis && UA.isTB) {
  _tbFile = tbFile;
} else if (UA.isWindVane) {
  _tbFile = tbFile2;
}
if (!_tbFile) {
  _tbFile = notSupport;
}
var tbFile3 = {
  get get() {
    if (_tbFile["get"]) {
      return _tbFile["get"];
    } else {
      return notSupport;
    }
  },
  get set() {
    if (_tbFile["set"]) {
      return _tbFile["set"];
    } else {
      return notSupport;
    }
  },
  get remove() {
    if (_tbFile["remove"]) {
      return _tbFile["remove"];
    } else {
      return notSupport;
    }
  },
  get clear() {
    if (_tbFile["clear"]) {
      return _tbFile["clear"];
    } else {
      return notSupport;
    }
  },
  get getSync() {
    if (_tbFile["getSync"]) {
      return _tbFile["getSync"];
    } else {
      return notSupport;
    }
  },
  get setSync() {
    if (_tbFile["setSync"]) {
      return _tbFile["setSync"];
    } else {
      return notSupport;
    }
  },
  get removeSync() {
    if (_tbFile["removeSync"]) {
      return _tbFile["removeSync"];
    } else {
      return notSupport;
    }
  },
  get clearSync() {
    if (_tbFile["clearSync"]) {
      return _tbFile["clearSync"];
    } else {
      return notSupport;
    }
  }
};
export {
  tbFile3 as tbFile
};
